<template>
  <div>
    <Stepper v-if="actualStep < stepperMaxStepShow" />
    <div class="guided-search-content__form" :class="{ 'guided-search-content__form--success': successStep }">
      <location v-if="actualStep === stepPositions.location" @next-step="nextStep" @set-loader="setLoading" />
      <capacity v-if="actualStep === stepPositions.capacity" @next-step="nextStep" />
      <installation-month v-if="actualStep === stepPositions.installation" @next-step="nextStep" />
      <duration v-if="actualStep === stepPositions.duration" @next-step="nextStep" />
      <budget v-if="actualStep === stepPositions.budget" />
      <user v-if="actualStep === stepPositions.phone" :default-phone-number="phoneNumberDefault" />

      <success v-if="successStep" />
      <success-small v-if="successSmallStep" />
      <div v-if="!successStep && !successSmallStep" class="guided-search-footer">
        <div class="guided-search-footer__actions">
          <button
            class="btn btn--primary right-arrow"
            :class="{
              'loading-btn': loading,
              'is-last-step': actualStep === stepPositions.phone
            }"
            :disabled="submitIsDisabled || loading"
            @click="nextStep"
          >
            {{ actualStep === stepPositions.phone ? trans('guided_search.form.send') : trans('global.validate') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="displayBackButton"
      class="guided-search-content__general-buttons"
      @click="previousStep"
    >
      {{ trans('guided_search.general.button.previous') }}
    </div>
  </div>
</template>

<script>
import eventBus from '@tools/event-bus';
import guidedSearchMixin from './guidedSearchMixin';
import Location from './steps/Location.vue';
import InstallationMonth from './steps/InstallationMonth.vue';
import Capacity from './steps/Capacity.vue';
import Duration from './steps/Duration.vue';
import Budget from './steps/Budget.vue';
import User from './steps/User.vue';
import Success from './steps/Success.vue';
import SuccessSmall from './steps/SuccessSmall.vue';
import Stepper from './Stepper.vue';
import { stepperMaxStepShow } from './guidedSearchEnum';

export default {
  components: {
    Stepper, Budget, Location, InstallationMonth, Capacity, Duration, User, Success, SuccessSmall,
  },
  mixins: [ guidedSearchMixin ],
  data() {
    return {
      loading: false,
      stepPositions: {
        location: 0,
        capacity: 1,
        installation: 2,
        duration: 3,
        budget: 4,
        phone: 5,
        success: 6,
        success_small: 7,
      },
      stepperMaxStepShow,
    };
  },
  computed: {
    successStep() {
      return this.actualStep === this.stepPositions.success;
    },
    successSmallStep() {
      return this.actualStep === this.stepPositions.success_small;
    },
    phoneNumberDefault() {
      if (this.getUserDefaultInfosData && this.getUserDefaultInfosData.phone) {
        return this.getUserDefaultInfosData.phone;
      }
      if (this.$store.getters['formGuidedSearch/getStepValue']('user')) {
        return this.$store.getters['formGuidedSearch/getStepValue']('user').phoneNumber;
      }
      return null;
    },
    displayBackButton() {
      if (this.successStep || this.successSmallStep) {
        return false;
      }
      return this.getLocationValues?.locationChoice
        && !this.successSmallStep
        && (this.actualStep > this.stepPositions.location || this.getLocationValues.locationChoice?.id < 2);
    },
  },
  methods: {
    async nextStep() {
      if (this.actualStep !== this.stepPositions.location) {
        this.setLoading(true);
        await this.waitTime(200);
      }
      if (this.actualStep === this.stepPositions.phone) {
        this.setLoading(true);
        const requestSuccess = await this.sendData();
        this.setLoading(false);

        if (!requestSuccess) {
          return;
        }
      }
      if (this.actualStep === this.stepPositions.location && this.getLocationValues?.locationChoice?.id === 1) {
        window.dataLayer.push({
          event: 'screenChange',
          event_name: 'district_area',
          funnel: 'support-contact-form',
          step: 'localisation',
          value: this.getLocationValues?.selectedTagsCity?.toString(),
        });
        this.setLoading(true);
        await this.waitTime(200);
      }
      if (this.actualStep === this.stepPositions.location && this.getLocationValues?.locationChoice?.id === 0) {
        window.dataLayer.push({
          event: 'screenChange',
          event_name: 'city_other',
          funnel: 'support-contact-form',
          step: 'localisation',
          value: `${this.getLocationValues.locationPostalCodeInput} ${this.getLocationValues.locationTownInput}`,
        });
        this.setLoading(true);
        await this.waitTime(200);
      }
      const capacity = this.$store.getters['formGuidedSearch/getStepValue']('capacity');
      if (capacity && capacity.max === 4) {
        this.changeActualStep(this.stepPositions.success_small);
        return;
      }
      this.changeActualStep(this.actualStep + 1);
      await this.stepChangedEvent();
      this.setLoading(false);
    },
    previousStep() {
      if (this.actualStep === this.stepPositions.location) {
        eventBus.dispatchEvent(new CustomEvent('reset-component-location'));
      }

      if (this.actualStep !== this.stepPositions.location) {
        this.changeActualStep(this.actualStep - 1);
      }
      this.stepChangedEvent();
    },
    async stepChangedEvent() {
      await this.$nextTick();
      eventBus.dispatchEvent(new CustomEvent('sausage-step-changed'));
    },
    setLoading(value) {
      this.loading = value;
    },
  },
};
</script>
